<template>
  <div class="form-base">
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Полное наименование"
          outlined
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          v-mask="Mask.INN_FOREIGN_ORG"
          label="ИНН"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import { EMOJI, getValidationErrorText, INN_ROD } from '@/utils/validate';
import { Mask } from '@/constants';

export const proxyPersonForeignOrganizationModel = {
  name: '',
  inn: '',
};

export const proxyPersonForeignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN_ROD,
  },
};

export default {
  name: 'ProxyPersonForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    Mask,
    getValidationErrorText,
  }),
};
</script>
